var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rf-introduce"},_vm._l((_vm.introduce),function(item,index){return _c('p',{key:index,staticClass:"introduce-item",domProps:{"textContent":_vm._s(item)}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }